module.exports = __webpack_public_path__ + "img/logo.43db2e71.png";